<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2Q3nJg/tc-custom/9781612432618.jpg?1738443834314" alt="This image is the cover for the book Savory Cocktails"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Savory Cocktails
      </h1>
      <p class="bookDescription body article font2">
        <b>From an <i>LA Weekly </i>top five food blogger, innovative cocktail recipes that are savory, not sweet, with herbal, sour, smoky and rich flavors.</b><br/>  <br/> Move over sweet. Cocktail aficionados are mixing up creative concoctions that are herbaceous, smoky and strong. These rims are anything but sugarcoated. <i>Savory Coc</i>ktails shakes, stirs and strains nearly 100 hard-hitting distilled delights for a cornucopia of today’s coolest drinks. Using everything from classic liqueurs to innovative new bitters, the recipes in this book offer a stylish, sophisticated approach to complex-flavored cocktails like:<br/>  <br/> •Yuzu Sour<br/> •Green Tea Gimlet<br/> •Off-White Negroni<br/> •Pink Peppercorn Hot Gin Sling<br/> •Greens Fee Fizz<br/> •The Spice Trail<br/>  <br/> Packed with carefully crafted cocktails as well as information on tools, ingredients and imbibing history, <i>Savory Cocktails</i> goes way beyond just recipes. The devilish twists in this barman’s companion are taste tested and mixologist approved. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Greg Henry
      </h2>
      
      <p class="authorDescription body article">In 2008 Greg Henry began the food blog Sippity Sup—Serious Fun Food (www.sippitysup.com). He is now the author of Savory Pies, writes a column on entertaining for “The Back Burner” at Key Ingredient (www.keyingredient.com), and is active in the food blogging community. He’s led cooking demonstrations in Panama and Costa Rica and has journeyed as far afield as Norway to promote culinary travel. He’s been featured in Food & Wine magazine, the Los Angeles Times, More magazine, the Today Show online, the Huffington Post, Edible, Foodie Crush, and Saveur magazine’s “Best of the Web.” Greg also cohosts “The Table Set” (downloadable on iTunes or at Homefries.com), named by LA Weekly as one of their five favorite podcasts for food lovers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20224782